module.exports = __webpack_public_path__ + "static/media/bd1.a71a6dc4.jpg";